// extracted by mini-css-extract-plugin
export default {"blogCards":"blogCards___e6d8eedf0d7a0c163c73","cards":"cards___a884cbd6bf3c08b4c2a8","pagination":"pagination___f35bf6d681754c6a3883"};